import { AppFeature } from '../../types/AppConstants';
import { DataSyncProductStore, Product } from './DataSyncProductsStore';

export class DataSyncDestinationProductStore extends DataSyncProductStore {

  private DESTINATION_PRODUCTS = [
    {
      display_name: 'Optimizely Graph',
      name: 'CGR',
      icon: '/assets/content_graph.svg'
    },
    {
      display_name: 'OCP App',
      name: 'HUB_APP',
      icon: '/assets/data_platform.svg'
    }
  ];

  public getProductList(): Product[] {
    return this.DESTINATION_PRODUCTS.map((product) => {
      return {
        text: product.display_name,
        value: product.name,
        iconPath: product.icon
      };
    });
  }

  public getProduct(productName: string): Product | null {
    const productMap = this.DESTINATION_PRODUCTS.find((product) => product.name === productName);
    if (productMap) {
      return {
        text: productMap.display_name,
        value: productMap.name,
        iconPath: productMap.icon
      };
    }
    return null;
  }

  protected getAppFeatureType(): string {
    return AppFeature.DESTINATION_APP;
  }
}
